<script lang="ts">
/**
 * Search text input with clear button.
 *
 * Wraps Nuxt UI's `UInput` with a search icon and a clear button that
 * appears when the field has content. Binds to `v-model` for two-way
 * search string binding.
 *
 * @example
 * ```vue
 * <SearchInput v-model="query" placeholder="Search items..." />
 * ```
 */
export interface SearchInputProps {
  /** Placeholder text. @defaultValue `"Search..."` */
  placeholder?: string
}
</script>

<script setup lang="ts">
import { ICON } from "@/lib/icons"

defineProps<SearchInputProps>()

const search = defineModel<string>()
</script>

<template>
  <UInput
    v-model="search"
    type="text"
    size="xl"
    :leading-icon="ICON.search"
    :placeholder="placeholder ?? 'Search...'"
  >
    <template #trailing>
      <UButton
        v-if="search?.length"
        :icon="ICON.close"
        color="neutral"
        variant="link"
        size="xs"
        :padded="false"
        @click="
          () => {
            search = ''
          }
        "
      />
    </template>
  </UInput>
</template>
